import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { DocumentIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createEndOfJourneyTemplate } from '../../../api/end-of-journey-templates/create-end-of-journey-template'
import UserNavBar from '../../../components/elements/nav-bar'
import EndOfStayTemplateForm from '../../../components/pages/surveys/end-of-stay-template-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const EndOfStayTemplateCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createEndOfJourneyTemplate,
    onError: showAxiosError,
    onSuccess: () => toast.success("Modèle d'enquête créé avec succès")
  })

  return (
    <div>
      <UserNavBar title="Créer un template d'appréciation de fin de séjour" icon={DocumentIcon} />
      <div className="h-4" />
      <Box>
        <Typography variant="sub-heading">
          Configurez les informations de base de votre template
        </Typography>
        <div className="h-4" />
        <EndOfStayTemplateForm
          buttonsConfig={twoButtonsConfig({
            confirmText: 'Créer et ajouter des questions',
            cancelText: 'Annuler',
            onConfirm: async (values) => {
              const result = await mutateAsync(values)
              navigate(
                Paths.SURVEY_END_OF_STAY_TEMPLATE_QUESTIONS_LIST_PAGE.replace(
                  ':id',
                  result.id.toString()
                )
              )
            },
            onCancel: () => back(Paths.SURVEY_END_OF_STAY_TEMPLATES_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default EndOfStayTemplateCreatePage
